

















import { CheckIsMUZE } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

const IsMUZE = CheckIsMUZE();

@Component
export default class extends Vue {
  private show = false;
  private optionList = [
    {
      name: "ManualPEAKAsset",
      icon: "far fa-file-alt",
      link:
        "https://intercom.help/peak/en/collections/3474327-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%97%E0%B8%B1%E0%B8%9E%E0%B8%A2-%E0%B8%9A%E0%B8%99-peak-asset",
      isShow: !IsMUZE,
    },
    {
      name: "VideoUserManual",
      icon: "fas fa-play",
      link: "https://www.youtube.com/playlist?list=PLKx_LgGwE9YNHZx4IAYidxQtxhow62xm1",
      isShow: true,
    },
  ];

  public hide() {
    this.show = false;
  }
}
